import React from "react";
import Button from "./Partial/Button";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ArrowLeftIcon from "../assets/Icons/ArrowLeftIcon";

const expactBackOptionsList = [
  "/",
  "/admin/projects",
  "/admin/projects",
  "/admin/users",
];

function Header() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.project?.user);

  const handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        localStorage.removeItem("token");
        // Clear session cookie by making it expire
        document.cookie = "session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        navigate("/auth/login");
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const handleBack = () => {
    navigate(-1);
  };

  const homeLink = user?.role == "admin" ? "/admin/projects" : "/";

  return (
    <div className="w-full h-24 bg-[#00428c] flex justify-center items-center fixed z-40">
      <div className="w-[95%] flex justify-between items-center">
        {!expactBackOptionsList.includes(window.location.pathname) && (
          <div className="">
            <Button
              text="Back"
              onClick={handleBack}
              bgColor="white"
              textColor="black"
              className="px-3"
              icon={ArrowLeftIcon}
            />
          </div>
        )}
        <Link className="text-[#fff] cursor-pointer" to={homeLink}>
          <div className="w-32" style={{ height: "63px" }}>
            <img
              src="/Logo_Transaprent.png"
              alt="logo"
              className="w-full h-full"
            />
          </div>
        </Link>
        <div className="flex gap-5">
          <Button text="Logout" onClick={handleLogout} />
          {/* <div className="flex flex-col">
            <p className="text-[#fff] text-sm">Welcome.</p>
            <p className="text-[#fff] text-sm">Harsh Gajera</p>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Header;
